import { EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
var PasswordStepComponent = /** @class */ (function () {
    function PasswordStepComponent() {
        this.authenticate = new EventEmitter();
        this.authWithGoogle = new EventEmitter();
        this.authWithAd = new EventEmitter();
        this.returnToEmailStep = new EventEmitter();
    }
    return PasswordStepComponent;
}());
export { PasswordStepComponent };
